import Vue from 'vue'

import Qs from 'qs'

class FilterGroups {
  async suggest() {
    return await Vue.axios
      .get('app/filter-groups/suggest')
  }

  async index({params}) {
    return await Vue.axios
      .get('app/filter-groups', {
        params,
        paramsSerializer: (params) => {
          return Qs.stringify(params)
        }
      })
  }

  async create({data}) {
    return await Vue.axios
      .post('app/filter-groups', data)
  }

  async read({id}) {
    return await Vue.axios
      .get('app/filter-groups/' + id)
  }

  async update({id, data}) {
    return await Vue.axios
      .put('app/filter-groups/' + id, data)
  }

  async delete({id}) {
    return await Vue.axios
      .delete('app/filter-groups/' + id)
  }
}

const filterGroups = new FilterGroups()

export default filterGroups
